/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {}
const version = 3.0;

type Condition = {
  name: string;
  parameter: string | null;
  value: string;
  negated: boolean | null;
};
type ConditionGroup = {
  operator: "AND" | "OR";
  conditions: (Condition | ConditionGroup)[];
};

export default class DimensionsViewer3D {
  private static _viewer: any;

  constructor() {
    //-- init-stuff
  }

  private static TestData = {
    type: "customDimensions",
    version: 3.0,
    data: {
      options: {
        id: 0,
        decimals: 1,
        line: {
          width: 0.01,
          color: { r: 100, g: 100, b: 100 },
        },
        arrow: {
          outer: false,
          length: 2,
          width: 5,
          color: { r: 0, g: 0, b: 0 },
        },
        helpLines: {
          overhang: 0.05,
          offset: { x: 20, y: 0, z: 0 },
        },
        label: {
          text: null,
          offset: 0.95,
          orientation: "x",
          size: 0.8,
          textColor: { r: 136, g: 136, b: 136, a: 1 },
          backgroundColor: { r: 255, g: 255, b: 255, a: 0 },
        },
      },
      settings: [
        {
          id: "P4-SW-1",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: 40 } },
            label: { text: null, orientation: "z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P4", parameter: "SW", value: "1" }],
            },
            instances: {
              start: { name: "P1", anchor: "AN_SRC" },
              end: { name: "P4", anchor: "AN_DIM_SWO_E" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P4-SW-2",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: 40 } },
            label: { orientation: "z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P4", parameter: "SW", value: "1" }],
            },
            instances: {
              start: { name: "P4", anchor: "AN_DIM_SW_S" },
              end: { name: "P4", anchor: "AN_DIM_SW_E" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P4-SW-M",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: -5, y: 0, z: -15 },
            label: { orientation: "-x", placement: "bottom" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P4", parameter: "SW", value: "1" }],
            },
            instances: {
              start: { name: "P4", anchor: "AN_DIM_SW_M" },
            },
            adjustments: {
              label: {
                type: "override",
                content: [
                  { value: "SW ", valueType: "text" },
                  { value: "P4.SW_SIZE", valueType: "param" },
                ],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P1P3-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: 35 } },
            label: { orientation: "z" },
          },
          properties: {
            instances: {
              start: { name: "P1", anchor: "AN_SRC" },
              end: { name: "P3", anchor: "AN_TAR" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P2P3-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: 35 } },
            label: { orientation: "z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P1", negated: true }],
            },
            instances: {
              start: { name: "P2", anchor: "AN_SRC" },
              end: { name: "P3", anchor: "AN_TAR" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P1-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: 29 } },
            label: { orientation: "z" },
          },
          properties: {
            instances: {
              start: { name: "P1", anchor: "AN_SRC" },
              end: { name: "P1", anchor: "AN_TAR" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P1-D",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: -20, y: 0, z: 0 } },
            label: { orientation: "-x" },
          },
          properties: {
            instances: {
              start: { name: "P1", anchor: "AN_DIM_FD_S" },
              end: { name: "P1", anchor: "AN_DIM_FD_E" },
            },
            adjustments: {
              label: {
                type: "append",
                content: [
                  { value: " ", valueType: "text" },
                  { value: "P1.FT", valueType: "param" },
                ],
                rotation: -90,
              },
            },
            unique: "false",
          },
        },
        {
          id: "P2-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: 29 } },
            label: { orientation: "z" },
          },
          properties: {
            instances: {
              start: { name: "P2", anchor: "AN_SRC" },
              end: { name: "P2", anchor: "AN_TAR" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P2-D",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: -25, y: 0, z: 0 } },
            label: { orientation: "-x" },
          },
          properties: {
            instances: {
              start: { name: "P2", anchor: "AN_DIM_FD_S" },
              end: { name: "P2", anchor: "AN_DIM_FD_E" },
            },
            unique: "false",
            adjustments: {
              label: {
                type: "append",
                content: [
                  { value: " ", valueType: "text" },
                  { value: "P2.FT", valueType: "param" },
                ],
                rotation: -90,
              },
              helpLines: {
                offset: {
                  x: { type: "-", value: "P1.L", valueType: "param" },
                },
              },
            },
          },
        },
        {
          id: "P2-DD",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: 0.01, y: 0, z: 0 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P2", parameter: "PR", value: "0" }],
            },
            instances: {
              start: { name: "P2", anchor: "AN_DIM_FDM_S" },
              end: { name: "P2", anchor: "AN_DIM_FDM_E" },
            },
            unique: "false",
            adjustments: {
              label: { type: "override", value: " ", valueType: "text" },
            },
          },
        },
        {
          id: "P2-DD-Lead",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: 0, y: 0, z: -10 },
            label: { orientation: "-z", placement: "left", rotate: 90 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P2", parameter: "PR", value: "0" }],
            },
            instances: {
              start: { name: "P2", anchor: "AN_DIM_FDM_E" },
            },
            unique: "false",
            adjustments: {
              label: {
                type: "override",
                value: "P2.SIZE_1",
                valueType: "param",
              },
            },
          },
        },
        {
          id: "P2-PR-L",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: 0, y: 0, z: -20 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P2", parameter: "PR", value: "1" }],
            },
            instances: {
              start: { name: "P2", anchor: "AN_PR_S" },
              end: { name: "P2", anchor: "AN_PR_E" },
            },
            unique: "false",
            adjustments: {},
          },
        },
        {
          id: "P2-PR-Pos",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: -20 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P2", parameter: "PR", value: "1" }],
            },
            instances: {
              start: { name: "P2", anchor: "AN_PR_E" },
              end: { name: "P2", anchor: "AN_TAR" },
            },
            unique: "false",
            adjustments: {
              label: { type: "append", value: " +0.05", valueType: "text" },
            },
          },
        },
        {
          id: "P1-CS-Type",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: -10, y: 0, z: 0 } },
            label: { orientation: "-x", rotate: 90 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P1", parameter: "CS", value: "1" },
                { name: "P1", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P1", anchor: "AN_DIM_CSD_S" },
              end: { name: "P1", anchor: "AN_DIM_CSD_E" },
            },
            adjustments: {
              label: {
                type: "override",
                value: "P1.CS_TYPE",
                valueType: "param",
              },
            },
            unique: "false",
          },
        },
        {
          id: "P1-CS-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: -20 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P1", parameter: "CS", value: "1" },
                { name: "P1", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P1", anchor: "AN_DIM_CSLL_S" },
              end: { name: "P1", anchor: "AN_DIM_CSLL_E" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P1-CS-TX",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: -10, y: 0, z: -20 },
            label: { orientation: "-x", placement: "bottom", rotate: 0 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P1", parameter: "CS", value: "1" },
                { name: "P1", parameter: "CUT", value: "0" },
              ],
            },
            instances: {
              start: { name: "P1", anchor: "AN_SRC" },
            },
            adjustments: {
              label: {
                type: "override",
                content: [{ value: "P1.CS_LEAD_TX", valueType: "param" }],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P2-CS-Type",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: -10, y: 0, z: 0 } },
            label: { orientation: "-x", rotate: 90 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P2", parameter: "CS", value: "1" },
                { name: "P2", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P2", anchor: "AN_DIM_CSD_S" },
              end: { name: "P2", anchor: "AN_DIM_CSD_E" },
            },
            adjustments: {
              label: {
                type: "override",
                value: "P2.CS_TYPE",
                valueType: "param",
              },
            },
            unique: "false",
          },
        },
        {
          id: "P2-CS-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: -20 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P2", parameter: "CS", value: "1" },
                { name: "P2", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P2", anchor: "AN_DIM_CSLL_S" },
              end: { name: "P2", anchor: "AN_DIM_CSLL_E" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P2-CS-TX",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: -10, y: 0, z: -20 },
            label: { orientation: "-x", placement: "bottom", rotate: 0 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P2", parameter: "CS", value: "1" },
                { name: "P2", parameter: "CUT", value: "0" },
              ],
            },
            instances: {
              start: { name: "P2", anchor: "AN_SRC" },
            },
            adjustments: {
              label: {
                type: "override",
                content: [{ value: "P2.CS_LEAD_TX", valueType: "param" }],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P1-PK-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: 23 } },
            label: { orientation: "z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P1", parameter: "PK", value: "1" }],
            },
            instances: {
              start: { name: "P1", anchor: "AN_DIM_PKL_S" },
              end: { name: "P1", anchor: "AN_DIM_PKL_E" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P1-PK-D",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: 0.01, y: 0, z: 0 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P1", parameter: "PK", value: "1" }],
            },
            instances: {
              start: { name: "P1", anchor: "AN_DIM_PKD_S" },
              end: { name: "P1", anchor: "AN_DIM_PKD_E" },
            },
            adjustments: {
              label: { type: "override", value: " ", valueType: "text" },
            },
            unique: "false",
          },
        },
        {
          id: "P1-PK-Pos",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: 23 } },
            label: { orientation: "z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P1", parameter: "PK", value: "1" }],
            },
            instances: {
              start: { name: "P1", anchor: "AN_PK_OFFSET" },
              end: { name: "P1", anchor: "AN_DIM_PKL_S" },
            },
            adjustments: {},
            unique: "false",
          },
        },
        {
          id: "P1-PK-D-Lead",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: 0, y: 0, z: -20 },
            label: { orientation: "-z", placement: "left", rotate: 90 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P1", parameter: "PK", value: "1" }],
            },
            instances: {
              start: { name: "P1", anchor: "AN_DIM_PKD_E" },
            },
            adjustments: {
              label: {
                type: "override",
                content: [
                  { value: "P1.PK_D", valueType: "param" },
                  { value: " ", valueType: "text" },
                  { value: "P1.PK_TYPE", valueType: "param" },
                ],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P1-CB1-Lead",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: -10, y: 0, z: -20 },
            label: { orientation: "-x", placement: "bottom", rotate: 0 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P1", parameter: "CB", value: "1" }],
            },
            instances: {
              start: { name: "P1", anchor: "AN_SRC" },
            },
            adjustments: {
              label: {
                type: "override",
                content: [
                  { value: "ISO 6411-B??/", valueType: "text" },
                  { value: "P1.CB_TYPE", valueType: "param" },
                ],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P1-CB2-D",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: -10, y: 0, z: 0 } },
            label: { orientation: "-x", rotate: 90 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P1", parameter: "CB", value: "2" },
                { name: "P1", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P1", anchor: "AN_CB2_O" },
              end: { name: "P1", anchor: "AN_CB2_U" },
            },
            adjustments: {
              label: {
                type: "prepend",
                content: [{ value: "M", valueType: "text" }],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P1-CB2-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: -10 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P1", parameter: "CB", value: "2" },
                { name: "P1", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P1", anchor: "AN_CB2_U" },
              end: { name: "P1", anchor: "AN_CB2_L" },
            },
            unique: "false",
          },
        },
        {
          id: "P1-CB3-D",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: -10, y: 0, z: 0 } },
            label: { orientation: "-x", rotate: 90 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P1", parameter: "CB", value: "3" },
                { name: "P1", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P1", anchor: "AN_CB3_O" },
              end: { name: "P1", anchor: "AN_CB3_U" },
            },
            adjustments: {
              label: {
                type: "prepend",
                content: [{ value: "SW", valueType: "text" }],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P1-CB3-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: -10 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P1", parameter: "CB", value: "3" },
                { name: "P1", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P1", anchor: "AN_CB3_U" },
              end: { name: "P1", anchor: "AN_CB3_L" },
            },
            unique: "false",
          },
        },
        {
          id: "P2-CB1-Lead",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: -10, y: 0, z: -20 },
            label: { orientation: "-x", placement: "bottom", rotate: 0 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [{ name: "P2", parameter: "CB", value: "1" }],
            },
            instances: {
              start: { name: "P2", anchor: "AN_SRC" },
            },
            adjustments: {
              label: {
                type: "override",
                content: [
                  { value: "ISO 6411-B??/", valueType: "text" },
                  { value: "P1.CB_TYPE", valueType: "param" },
                ],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P2-CB2-D",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: -10, y: 0, z: 0 } },
            label: { orientation: "-x", rotate: 90 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P2", parameter: "CB", value: "2" },
                { name: "P2", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P2", anchor: "AN_CB2_O" },
              end: { name: "P2", anchor: "AN_CB2_U" },
            },
            adjustments: {
              label: {
                type: "prepend",
                content: [{ value: "M", valueType: "text" }],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P2-CB2-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: -20 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P2", parameter: "CB", value: "2" },
                { name: "P2", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P2", anchor: "AN_CB2_U" },
              end: { name: "P2", anchor: "AN_CB2_L" },
            },
            unique: "false",
          },
        },
        {
          id: "P2-CB3-D",
          dimension: {
            group: "FLEX",
            arrow: { outer: true },
            helpLines: { offset: { x: -10, y: 0, z: 0 } },
            label: { orientation: "-x", rotate: 90 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P2", parameter: "CB", value: "3" },
                { name: "P2", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P2", anchor: "AN_CB3_O" },
              end: { name: "P2", anchor: "AN_CB3_U" },
            },
            adjustments: {
              label: {
                type: "prepend",
                content: [{ value: "SW", valueType: "text" }],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P2-CB3-L",
          dimension: {
            group: "FLEX",
            helpLines: { offset: { x: 0, y: 0, z: -20 } },
            label: { orientation: "-z" },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                { name: "P2", parameter: "CB", value: "3" },
                { name: "P2", parameter: "CUT", value: "1" },
              ],
            },
            instances: {
              start: { name: "P2", anchor: "AN_CB3_U" },
              end: { name: "P2", anchor: "AN_CB3_L" },
            },
            unique: "false",
          },
        },
        {
          id: "P1-CB-TX",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: -10, y: 0, z: -20 },
            label: { orientation: "-x", placement: "bottom", rotate: 0 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                {
                  operator: "OR",
                  conditions: [
                    { name: "P1", parameter: "CB", value: "1" },
                    { name: "P1", parameter: "CB", value: "2" },
                    { name: "P1", parameter: "CB", value: "3" },
                  ],
                },
                { name: "P1", parameter: "CUT", value: "0" },
              ],
            },
            instances: {
              start: { name: "P1", anchor: "AN_SRC" },
            },
            adjustments: {
              label: {
                type: "override",
                content: [{ value: "P1.CB_LEAD_TX", valueType: "param" }],
              },
            },
            unique: "false",
          },
        },
        {
          id: "P2-CB-TX",
          dimension: {
            type: "leader",
            group: "FLEX",
            offset: { x: -10, y: 0, z: -20 },
            label: { orientation: "-x", placement: "bottom", rotate: 0 },
          },
          properties: {
            condition: {
              operator: "AND",
              conditions: [
                {
                  operator: "OR",
                  conditions: [
                    { name: "P2", parameter: "CB", value: "1" },
                    { name: "P2", parameter: "CB", value: "2" },
                    { name: "P2", parameter: "CB", value: "3" },
                  ],
                },
                { name: "P2", parameter: "CUT", value: "0" },
              ],
            },
            instances: {
              start: { name: "P2", anchor: "AN_SRC" },
            },
            adjustments: {
              label: {
                type: "override",
                content: [{ value: "P2.CB_LEAD_TX", valueType: "param" }],
              },
            },
            unique: "false",
          },
        },
      ],
    },
  };

  static Create(viewer: any): void {
    if (process.env.NODE_ENV === "development") {
      console.log("VIEWER:", viewer);
    }

    this._viewer = viewer;
    this.removeGroup("FLEX");

    const data = this.loadCustomDimensions();
    if (process.env.NODE_ENV === "development") {
      if (this.TestData.version !== version) {
        console.log("%cWRONG DIM VERSION", "color: #FF0000");
      } else {
        data.options = this.TestData.data.options;
        data.settings = this.TestData.data.settings;
      }
    }

    data.settings?.forEach((setting: any) => {
      const options = JSON.parse(JSON.stringify(data.options));
      const dimType = setting.dimension.type;

      //-- Check Conditions
      const condition = this.evaluateCondition(setting.properties.condition);
      if (!condition) {
        return;
      }

      //-- Retrieve Instances
      const startInstance = this.getInstanceByName(
        setting.properties.instances.start.name,
      );
      const endInstance = this.getInstanceByName(
        setting.properties.instances.end?.name,
      );

      if (!startInstance || (!endInstance && dimType !== "leader")) {
        return;
      }

      //-- Retrieve Anchors
      const start = this.getAnchorByNameAndId(
        setting.properties.instances.start.anchor,
        startInstance,
      );
      const end = this.getAnchorByNameAndId(
        setting.properties.instances.end?.anchor,
        endInstance,
      );
      if (!start || (!end && dimType !== "leader")) {
        return;
      }

      //-- Prepare Options
      options.id = setting.id;
      options.group = setting.dimension.group;
      options.arrow.outer =
        setting.dimension.arrow?.outer ?? options.arrow?.outer;
      options.arrow.length =
        setting.dimension.arrow?.length ?? options.arrow?.length;
      options.helpLines.offset = { ...setting.dimension.helpLines?.offset };
      options.label.orientation = setting.dimension.label.orientation;
      options.label.rotate = setting.dimension.label.rotate ?? 0;
      options.label.offset =
        setting.dimension.label.offset ?? options.label.offset;

      //-- HelpLines überschreiben
      if (setting.properties.adjustments?.helpLines) {
        const helpLines = setting.properties.adjustments.helpLines;
        this.checkHelplineOffset(options.helpLines.offset, helpLines.offset);
      }

      //-- Dimensions erstellen
      if (dimType === "leader") {
        options.offset = { ...setting.dimension.offset };
        options.label.placement = setting.dimension.label.placement;

        const labelValue = this.retrieveLabel(
          setting.properties.adjustments.label,
        );
        viewer?.Tools.Dimensions.createLeader(start, labelValue, options);
      } else {
        viewer?.Tools.Dimensions.create([start, end], options);

        //-- Labels anpassen
        const dimension = viewer?.Tools.Dimensions.getDimensionById(options.id);
        this.handleDecimals(dimension);

        if (setting.properties.adjustments?.label) {
          const label = setting.properties.adjustments.label;

          this.updateDimensionLabel(dimension, label);
        }
      }

      if (process.env.NODE_ENV === "development") {
        console.log("DIMENSION:", setting.id, {
          settings: setting,
          startInstance: startInstance,
          endInstance: endInstance,
          startAnchor: start,
          endAnchor: end,
          options: options,
          dimension: viewer?.Tools.Dimensions.getDimensionById(options.id),
        });
      }
    });

    if (process.env.NODE_ENV === "development") {
      console.log("DIMENSIONS:", viewer?.Tools.Dimensions);
    }

    viewer?.Camera.fitZoom({ zoomValue: 0.5 });
  }

  private static getAnchorByNameAndId(
    name: string,
    instance: any | undefined,
  ): any | undefined {
    if (typeof instance === "undefined") {
      return undefined;
    }

    return this._viewer?.getAnchorByNameAndId(name, instance.id);
  }
  private static getInstanceByName(name: string): any | undefined {
    return DimensionsViewer3D._viewer
      .getAllInstances()
      .map((instance: any) => {
        instance.name = instance.name.split("/").pop();
        return instance;
      })
      .find((instance: any) => instance?.name === name);
  }
  private static removeGroup(name: string): void {
    const Dimensions = DimensionsViewer3D._viewer?.Tools.Dimensions;

    const lines = Dimensions.lines
      .filter((line: any) => line.groupName === name)
      .map((line: any) => line.instanceId);

    lines.forEach((line: string) => Dimensions.removeById(line));
  }
  private static loadCustomDimensions(): any {
    const v3d = this._viewer;
    const data = v3d.Options.materialLibrary.custom.materialList;

    if (data.length !== 1) {
      return {};
    }

    const settings = data[0];
    if (settings.type !== "customDimensions") {
      return {};
    }

    if (settings.version !== version) {
      console.log("%cWRONG DIM VERSION", "color: #FF0000");
      console.log("%cDEFAULT WILL BE USED!", "color: #91ff00");

      return this.TestData.data;
    } else {
      return settings.data;
    }
  }
  private static updateDimensionLabel(dimension: any, label: any): void {
    const value = this.retrieveLabel(label);

    switch (label.type) {
      case "override":
        dimension.updateLabel(value);
        break;

      case "append":
        dimension.updateLabel(`${dimension.Label.text}${value}`);
        break;

      case "prepend":
        dimension.updateLabel(`${value}${dimension.Label.text}`);
        break;

      default:
        break;
    }

    //-- Add possible rotation
    if (label.rotation) {
      const toRad = (deg: any): number => deg * -1 * (Math.PI / 180);
      dimension.Label.mesh.material.rotation = toRad(label.rotation);
    }

    this._viewer.Scene.setRenderFlagTrue();
  }
  private static retrieveLabel(label: any): string | undefined {
    if (label.content) {
      return label.content
        .map((item: any) => {
          return this.getLabelValue(item);
        })
        .join("");
    } else {
      return this.getLabelValue(label);
    }
  }
  private static getLabelValue(item: any): string | undefined {
    if (typeof item.value === "undefined") {
      return undefined;
    }
    const valueType = item.valueType ? item.valueType : "text";

    switch (valueType) {
      case "param":
        return this.getInstanceParamValue(item.value);

      case "text":
      default:
        return item.value;
    }
  }
  private static handleDecimals(dimension: any): void {
    const value = dimension?.Label.text;

    if (value && value.endsWith(".0")) {
      dimension.updateLabel(parseInt(value).toString());
    }
  }
  private static getInstanceParamValue(value: string): string | undefined {
    const [instanceName, paramName] = value.split(".");
    const instance = this.getInstanceByName(instanceName);
    const parameter = instance?.product.parameters.find(
      (p: any) => p.question === paramName,
    );

    if (!parameter) {
      return undefined;
    }

    return parameter.value;
  }
  private static checkHelplineOffset(currentOffset: any, newOffset: any): void {
    Object.keys(newOffset).forEach((key: string) => {
      let tmpValue = "0";
      let newValue = parseFloat(currentOffset[key]);

      switch (newOffset[key].valueType) {
        case "text":
          tmpValue = "0";
          break;

        case "param":
          tmpValue = this.getInstanceParamValue(newOffset[key].value) ?? "0";
          break;

        default:
          break;
      }

      switch (newOffset[key].type) {
        case "+":
          newValue += parseFloat(tmpValue);
          break;

        case "-":
          newValue -= parseFloat(tmpValue);
          break;

        default:
          break;
      }

      currentOffset[key] = newValue;
    });
  }

  private static isCondition(c: Condition | ConditionGroup): c is Condition {
    return "name" in c;
  }
  private static evaluateCondition(node: ConditionGroup): boolean {
    const check = (node: Condition | ConditionGroup): boolean => {
      if (this.isCondition(node)) {
        return this.checkCondition(node);
      }

      return node.operator === "AND"
        ? node.conditions.every(check)
        : node.conditions.some(check);
    };

    if (!node) {
      return true;
    }
    return check(node);
  }
  private static checkCondition(condition: any): boolean {
    if (!condition) {
      return true;
    }

    const negated = condition.negated ?? false;
    const instance = this.getInstanceByName(condition.name);
    const hasParameter = condition.parameter ?? false;

    if (hasParameter && instance) {
      const paramValue = instance.product.getParameter(condition.parameter);

      if (negated) {
        return paramValue !== condition.value;
      } else {
        return paramValue === condition.value;
      }
    } else {
      if (negated) {
        return typeof instance === "undefined";
      } else {
        return typeof instance !== "undefined";
      }
    }
  }
}
